// extracted by mini-css-extract-plugin
export default {"pageTitle":"PageTitle-module__pageTitle___W8avn"};